import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75825542"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "testimonial-page pt-227 pb-100"
}
const _hoisted_2 = { class: "pb-100" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title mw-600" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "Our Celebrities"),
  /*#__PURE__*/_createElementVNode("h2", null, "Exclusively shining with us — only on MyCelebrity.")
], -1))
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "testimonial-img position-relative mb-4 mb-lg-0 d-inline-block" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "testimonial-quot" }
const _hoisted_11 = { class: "testimonial-info ms-0 text-start" }
const _hoisted_12 = { class: "testimonial-actions" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://play.google.com/store/apps/details?id=com.mycelebrity.app",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "testimonial-btn play-store-btn"
}, "Download App on Play Store", -1))
const _hoisted_15 = {
  key: 1,
  class: "testimonial-page pt-227 pb-100"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, {
      class: "bg-transparent fixed-top border-bottom",
      mwClass: "",
      className: "m-auto"
    }),
    (_ctx.member)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: `http://localhost:5001/api/team/${_ctx.member.id}/image`,
                      alt: _ctx.member.name,
                      class: "testimonial-img"
                    }, null, 8, _hoisted_8)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.member.testimonial), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.member.name), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.member.designation), 1),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_router_link, {
                          to: "/get-your-wish",
                          class: "testimonial-btn"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Get your wish")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          to: "/business-enquiry",
                          class: "testimonial-btn"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Business Enquiry")
                          ]),
                          _: 1
                        }),
                        _hoisted_13,
                        _hoisted_14
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17)),
    _createVNode(_component_MainFooter)
  ], 64))
}